import FormFieldViewTextCopyWrapper from "components/FormFields/ViewText/CopyWrapper";
import { Commit as CommitIcon } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import { Commit, VcsProvider } from "types/generated";
import { getCommitLabel } from "utils/commit";

import { getPushCommitUrl } from "./helpers";

type StackRunsPushCommitsDrawerCommitProps = {
  sha: string;
  headCommit: Pick<Commit, "hash" | "url">;
  provider: VcsProvider;
};

const StackRunsPushCommitsDrawerCommit = ({
  sha,
  headCommit,
  provider,
}: StackRunsPushCommitsDrawerCommitProps) => {
  const isHead = sha === headCommit.hash;
  const commitLabel = getCommitLabel(provider, sha);
  const label = isHead ? `${commitLabel} (HEAD)` : commitLabel;
  const url = getPushCommitUrl(sha, headCommit, provider);

  return (
    <FormFieldViewTextCopyWrapper value={sha}>
      {url && <MetaInfoListItem icon={CommitIcon} href={url} linkText={label} target="_blank" />}
      {!url && <MetaInfoListItem icon={CommitIcon}>{label}</MetaInfoListItem>}
    </FormFieldViewTextCopyWrapper>
  );
};

export default StackRunsPushCommitsDrawerCommit;
